import React from 'react'
import './School.css'

export default function SchoolCards({ image, place, caption, style, logo, backgroundColor, color, altText, logoAltText }) {
  return (
    <div className='schools'>
        <div className='school'>
            <img className='school-picture' src={image} alt={altText} />
            <div className='home-description description' style={{ ...style, backgroundColor: backgroundColor }} >
                <div className='home'>
                    <p className='school-p' style={{ ...style, color: color }}>{place}</p>
                </div>
                <div className='options'>
                    <img src={logo} alt={logoAltText} />
                </div>
            </div>
            <div className="caption">{caption}</div>
        </div>
    </div>
  );
}